module.exports = __webpack_public_path__ + "img/groupicon.5269e69.png";